import { format } from "date-fns";
import { nextDate, startEndDate } from "../../../utils/EventoUtils";
import { Status } from "../../../utils/Status";
import { VerifyPermits } from "../../../utils/Permisos";

const Evento = ({ data, onClick, navigate, user }) => {
  return (
    <tr>
      <td className="d-none d-md-table-cell">
        <div className="" style={{ height: "150px" }}>
          <img
            src={`https://www.antesala.com.ar/assets/img/eventos/${data.imagen}`}
            className="w-100 h-100"
            style={{ objectFit: "cover" }}
            alt=""
          />
        </div>
      </td>
      <td className="Grifter d-none d-md-table-cell">#{data.id}</td>
      <td className="Grifter fs-6">
        {data.nombre}
        <span className="d-block d-md-none">
          {data.categorias.map((categoria) => {
            return (
              <span class="badge bg-secondary text-bg-secondary me-1 mb-1">
                {categoria.nombre}
              </span>
            );
          })}
        </span>
      </td>
      <td>{nextDate(data.fechas)}</td>
      <td className="d-none d-md-table-cell">
        {data.categorias.map((categoria) => {
          return (
            <span class="badge bg-secondary text-bg-secondary me-1 mb-1">
              {categoria.nombre}
            </span>
          );
        })}
      </td>
      <td className="d-none d-md-table-cell">{data.nombre_sitio}</td>
      <td className="d-none d-md-table-cell">
        {format(new Date(data.created_at), "dd/M/yyyy").toString()}
      </td>
      <td className="d-none d-md-table-cell">
        <div class="dropdown">
          <button
            class="btn text-white border fw-normal GothamBold px-3 py-2 fs-10 dropdown-toggle"
            style={{ borderRadius: "10px" }}
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {Status(data.status)}
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li>
              <label className="btn m-0 p-0">
                <i class="text-success mx-1 bi bi-check-circle-fill"></i>
                Activar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 1 })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-secondary mx-1 bi bi-slash-circle-fill"></i>
                Pausar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 3 })
                  }
                ></button>
              </label>
            </li>
            <li>
              <label className="btn m-0 p-0">
                <i class="text-info mx-1 bi bi-recycle"></i>
                Borradores
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 4 })
                  }
                ></button>
              </label>
            </li>

            <li>
              <label className="btn m-0 p-0 d-none">
                <i class="text-danger mx-1 bi bi-trash"></i>
                Eliminar
                <button
                  className="d-none"
                  name=""
                  onClick={(event) =>
                    onClick(event, { evento: data, status: 3 })
                  }
                ></button>
              </label>
            </li>
          </ul>
        </div>
      </td>

      <td>
        <label
          className={`btn btn-success me-1 mb-1 ${
            VerifyPermits(user, data.permisos).edicion ? "" : "d-none"
          }`}
        >
          <i class="bi bi-pencil-square"></i>
          <button
            className="d-none"
            name="editar-evento"
            onClick={(e) => onClick(e, data.id)}
          ></button>
        </label>

        <label
          className={`btn btn-primary me-1 mb-1 ${
            VerifyPermits(user, data.permisos).boleteria ? "" : "d-none"
          }`}
          title="Boleteria"
        >
          <i class="bi bi-ticket"></i>
          <button
            className="d-none"
            onClick={() => {
              return navigate(`/dashboard/boleteria/${data.id}`);
            }}
          ></button>
        </label>
      </td>
    </tr>
  );
};

export default Evento;
